import listSummaries from './list';
export default {
	listSummaries,
};



// WEBPACK FOOTER //
// ./routes/admin/routes/summary-list/reducer/index.js